import { api_post as JPost } from '@/utils/http.ts'
import CodeCountBtn from '@/components/enroll/CodeCountBtn.vue'
import ImgCode from '@/components/enroll/ImgCode.vue'
import enrollMixin from '@/components/enroll/enrollMixin.js'
import JSEncrypt from 'jsencrypt'
import { rsaKeyPair } from '@/components/enroll/login/api.js'

export default {
  mixins: [enrollMixin],
  data() {
    return {
      // 是否同意用户协议
      checked: false,
      // 注册loading
      loading: false,
      // 图形验证码
      imgCodeSrc: '',
      // 前端生成token
      token: '',
      // 是否成功发送手机验证码
      hasSent: false
    }
  },
  components: {
    CodeCountBtn,
    ImgCode
  },
  computed: {
    // 注册按钮能否点击
    registerUsable() {
      return this.tel && this.telCode && this.psw && this.checked && this.code
    }
  },
  mounted() {
    this.getNewImageCode()
  },
  methods: {
    // 图形验证码
    getNewCode() {
      this.getNewImageCode()
      window['sensors'].track('Loginpop_buttonClick', { buttonName: '验证码' })
    },
    // 获取新的图形验证码
    getNewImageCode() {
      try {
        this.token = String(new Date().getTime()) + Math.random()
        this.imgCodeSrc = location.origin + '/api/auth/captcha?captcha_token=' + this.token
      } catch (e) {
        this.token = String(new Date().getTime()) + Math.random()
        this.imgCodeSrc = location.origin + '/api/auth/captcha?captcha_token=' + this.token
      }
    },
    // 校验图形验证码
    async imgCodeValid() {
      if (!this.code) return false
      try {
        const { success } = await JPost('/api/auth/captcha', {
          // 图形验证码
          captcha: this.code,
          // 前端随机签名
          captcha_token: this.token
        })
        // 验证失败重新刷新验证码
        !success && this.getNewImageCode()
        return success
      } catch (err) {
        return false
      }
    },
    // 获取短信验证码错误提示
    errorHandler(errType, msg) {
      this[errType] = msg || ''
    },
    // 短信验证码发送成功
    handleSmsSendSuccess() {
      this.hasSent = true
    },
    // 点击服务协议
    onClickAgreement(e) {
      window['sensors'].track('RegisterAccountInformationPage_buttonClick', {
        buttonName: '用户服务协议'
      })
      setTimeout(() => {
        location.href = '/agree'
      }, 200)
      e.preventDefault()
    },
    // 点击登录
    onClickLogin(e) {
      window['sensors'].track('RegisterAccountInformationPage_buttonClick', {
        buttonName: '登录'
      })
      setTimeout(() => {
        location.href = '/'
      }, 200)
      e.preventDefault()
    },
    // 注册
    async register() {
      window['sensors'].track('RegisterAccountInformationPage_buttonClick', {
        buttonName: '注册按钮'
      })
      // 验证手机号
      if (!/^1\d{10}$/.test(this.tel)) {
        this.tel_error = '请输入11位手机号码'
        return
      }
      // 校验发送短信按钮是否点击
      if (!this.hasSent) {
        this.telCodeError = '请获取短信验证码！'
        return
      }
      // 验证密码
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{8,20}$/.test(this.psw)) {
        this.password_error = '请输入8~20位数字和字母组合'
        return
      }
      this.loading = true
      // 点击下一步，对手机号/密码加密
      let password = this.psw
      let phone = this.tel
      let skey = ''
      try {
        const { data, success, error } = await rsaKeyPair({})
        if (success) {
          const { key, public_key } = data
          skey = key
          // 对密码进行加密
          // 对手机号/账号进行加密
          let encryptor = new JSEncrypt()
          encryptor.setPublicKey(public_key)
          try {
            password = encryptor.encrypt(password)
            phone = encryptor.encrypt(phone)
          } catch (e) {
            console.log(e)
          }
        } else {
          console.log(error)
        }
      } catch(e) {
        console.log(e)
      }
      try {
        const res = await JPost('/api/auth/verification-code', {
          phone: phone,
          // 验证码
          verification_code: this.telCode,
          encrypted: 'phone', // 如果是多个，使用逗号拼接
          encryption_key: skey
        })
        if (!res.success) {
          this.telCodeError = res.error
          return
        }
        // 跳转到选择学科界面并传入参数
        this.$emit('changeCurrnetTab', 2, {
          phone,
          verification_code: this.telCode,
          password,
          // 新增图形验证码校验
          token: this.token,
          captcha: this.code,
          encrypted: 'password,phone', // 如果是多个，使用逗号拼接
          encryption_key: skey
        })
      } catch (err) {
      } finally {
        this.loading = false
      }
    }
  }
}
